// extracted by mini-css-extract-plugin
export default {"listItem":"PalletsTransferHistoryListItem_listItem__FRPXo"};